import React from "react";
import PropTypes from "prop-types";
import withIntl from "../../../utils/withIntl";
import { Chip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import EditSelect from "../../EditArticle/EditSelect";
import { getSupergroupsFromStores } from "../../../store/articles/ArticlesHelpers";

const useStyles = makeStyles(() => ({
  disabledTitle: { color: "lightgray" },
  rootButton: { fontSize: 12 },
}));

function Supergroups(props) {
  const classes = useStyles();
  const supergroups = props.article.getSupergroupTags();

  return (
    <AuthorizationWrapper
      permission={"supergroups"}
      child={(write) => {
        return (
          <div style={{ width: "100%" }}>
            <Typography classes={{ root: props.disabled && classes.disabledTitle }}>
              {props.intl.formatMessage({ id: "Supergroups" })}
            </Typography>
            <EditSelect
              helperText={
                Object.keys(getSupergroupsFromStores()).length === 0
                  ? props.intl.formatMessage({ id: "No supergroups" })
                  : null
              }
              fullWidth
              disabled={!write || props.disabled === true || Object.keys(getSupergroupsFromStores()).length === 0}
              value={supergroups}
              optionValues={getSupergroupsFromStores().map((supergroup) => supergroup.tag)}
              optionViewValues={getSupergroupsFromStores().map((supergroup) => supergroup.tag)}
              multiple={true}
              onChange={(value) => {
                props.onChange(value);
              }}
            />
            <div style={{ margin: 5 }}>
              {supergroups.length === 0 && (
                <Chip
                  color="primary"
                  classes={{ root: classes.rootButton }}
                  label={props.intl.formatMessage({ id: "None" })}
                />
              )}

              {supergroups.map((supergroup) => {
                return (
                  <Chip color="primary" key={supergroup} classes={{ root: classes.rootButton }} label={supergroup} />
                );
              })}
            </div>
          </div>
        );
      }}
    />
  );
}

Supergroups.propTypes = {
  article: PropTypes.object.isRequired,
};

export default withIntl(Supergroups);
